export default __webpack_public_path__ + "static/media/Panel_3_Stage1.5aa892e6.svg";